import { createContext, useContext } from 'react';

import {
  MetricsV1AggregationThreshold,
  MetricsV1AggregationType,
  MetricsV1ColumnType,
  MetricsV1ValueCap,
} from '@spotify/confidence-graphql';

type Measurement = { name: string } | null | undefined;

export type Measure = {
  column: {
    name: string;
    type?: MetricsV1ColumnType | null;
  };
};

export type AggregatedMeasurementContextValue = {
  measurement: Measurement;
  aggregationType: MetricsV1AggregationType;
  threshold: MetricsV1AggregationThreshold | null | undefined;
  cap: MetricsV1ValueCap | null | undefined;
  entity: string;
  factTable: string;
  measures: Measure[];
  enabledAggregationTypes: MetricsV1AggregationType[];
  onMeasurementChange: (name: string) => void;
  onAggregationTypeChange: (type: MetricsV1AggregationType) => void;
  onThresholdChange: (threshold: MetricsV1AggregationThreshold | null) => void;
  onCapChange: (cap: MetricsV1ValueCap | null) => void;
};

export const AggregatedMeasurementContext =
  createContext<AggregatedMeasurementContextValue | null>(null);

export const useAggregatedMeasurement = () => {
  const context = useContext(AggregatedMeasurementContext);
  if (!context) {
    throw new Error(
      'useAggregatedMeasurement must be used within AggregatedMeasurement.Root',
    );
  }
  return context;
};
